class FetchAnalyticsTrackingCodeService {
  constructor(rest) {
    this.rest = rest;
  }

  requestGA() {
    return this.rest('/api/v1/gaTrackingCode')
      .then(response => response.entity);
  }

  requestGTM() {
    return this.rest('/api/v1/gtmTrackingCode')
      .then(response => response.entity);
  }
}

export default FetchAnalyticsTrackingCodeService;



/** WEBPACK FOOTER **
 ** ./src/services/FetchAnalyticsTrackingCodeService.js
 **/